export default __webpack_public_path__ + "static/logo-490840c55299d930b7d9a0453adc06ba.svg";